import { Paragraph2 } from 'inpock-ui-react';

/**
 * orderline의 옵션 및 수량 정보를 받아서 이름 컴포넌트를 생성하는 util 함수
 * @param additional_product_name
 * @param additional_option_name
 * @param main_option_name
 * @param sub_option_name
 * @param quantity
 * @returns
 */
export const generateOrderlineName = (
  additional_product_name: string | null,
  additional_option_name: string | null,
  main_option_name: string | null,
  sub_option_name: string | null,
  quantity: number,
) => {
  return (
    <Paragraph2 color="gray500">
      {additional_product_name
        ? `[추가 상품] ${additional_product_name} / ${additional_option_name} / ${quantity}개`
        : main_option_name
        ? `${main_option_name} / ${sub_option_name ? `${sub_option_name} /` : ''} ${quantity}개`
        : `${quantity}개`}
    </Paragraph2>
  );
};
